import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import Lozenge from '@atlaskit/lozenge/lozenge';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import messages from '../remix-overlay/messages';

export function RemixLabsLozenge(): JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<Tooltip content={formatMessage(messages.labsLozengeTooltip)} position="top" delay={0}>
			{(tooltipProps) => (
				<Flex {...tooltipProps} justifyContent="end">
					<Lozenge appearance="discovery">
						<FormattedMessage {...messages.labsLozenge} />
					</Lozenge>
				</Flex>
			)}
		</Tooltip>
	);
}
